export default {
  data() {
    return {
      dialogVisible: false,
      columns: [{
        slots: {
          title: '退款单号'
        },
        dataIndex: 'refundNo',
        key: '1',
        align: 'center'
      }, {
        slots: {
          title: '退款金额'
        },
        dataIndex: 'totalFee',
        key: '2',
        align: 'center',
        width: 150
      }, {
        slots: {
          title: '退款时间'
        },
        dataIndex: 'createAt',
        key: '3',
        align: 'center',
        width: 200
      }, {
        slots: {
          title: '退款说明'
        },
        dataIndex: 'content',
        key: '4',
        align: 'center'
      }],
      data: []
    };
  },
  methods: {
    init(arr) {
      this.data = arr;
      this.dialogVisible = true;
    }
  }
};